<template>
  <div
    class="tw-text-black tw-flex tw-rounded-lg tw-mb-2 tw-overflow-hidden tw-border tw-border-gray-100"
    :class="ticketStatusRingColorClass[ticket.status]"
  >
    <!-- TODO: replace hardcoded URL with ticketsBaseUrl from '@/logic/common/urls' -->
    <a
      :href="`https://tickets.norm.eu/v2/tickets/${ticket.id}`"
      target="_blank"
      class="tw-place-self-stretch tw-no-underline"
    >
      <div
        :class="ticketStatusBgColorClass[ticket.status]"
        class="tw-px-2 tw-py-2 tw-h-full tw-text-black tw-items-center tw-flex tw-flex-col tw-gap-1 hover:tw-opacity-80 tw-text-xs tw-font-medium"
      >
        <div>#{{ ticket.id }}</div>
        <div v-if="ticket.case_id && showCase" class="tw-flex tw-items-center tw-gap-0.5">
          <OutlineBriefcaseIcon size="12" />
          <div>{{ ticket.case_id }}</div>
        </div>
      </div>
    </a>
    <div class="tw-grow tw-p-2 tw-text-sm">
      <div class="tw-flex tw-justify-between tw-mb-1">
        <div class="tw-font-medium">
          {{
            ticket.title ? `Onderhoud: ${ticket.title}` : ticketTypes[ticket.type] || ticket.type
          }}
        </div>
        <div class="tw-text-gray-500 tw-text-xs">
          {{ ticket.partner }}
        </div>
      </div>
      <div class="tw-flex tw-justify-between tw-items-end">
        <div class="tw-flex tw-flex-col">
          <div class="tw-text-xs">{{ ticketStatuses[ticket.status] }}</div>
          <div
            v-if="ticket.status !== 'approved' && ticket.status !== 'cancelled'"
            class="tw-text-xs tw-text-gray-400"
          >
            sinds {{ daysSince(ticket.latest_status_at) }} dagen
          </div>
        </div>
        <div class="tw-flex tw-items-center tw-gap-2">
          <div v-if="ticket.appointment_date" class="tw-text-xs tw-text-gray-500">
            {{ format(parseISO(ticket.appointment_date), 'd MMM yy') }}
          </div>
          <div
            v-if="editable"
            class="tw-p-1 tw-text-gray-400 hover:tw-text-gray-600 tw-cursor-pointer"
            @click.prevent="$emit('edit')"
          >
            <PencilIcon class="tw-w-4 tw-h-4" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { format, parseISO, differenceInDays } from 'date-fns'
import { BriefcaseIcon as OutlineBriefcaseIcon, PencilIcon } from '@vue-hero-icons/outline'
import { ticketStatuses, ticketStatusBgColorClass, ticketStatusRingColorClass } from '@/constants'

const emit = defineEmits(['edit'])

const props = defineProps({
  ticket: Object,
  editable: Boolean,
  showCase: {
    type: Boolean,
    default: true,
  },
})

const ticketTypes = {
  maintenance: 'Onderhoud',
  installation: 'Installatie',
  inspection: 'Schouw',
}

function daysSince(date) {
  return differenceInDays(new Date(), parseISO(date))
}
</script>
